// import { GooglePlus } from '@ionic-native/google-plus';
import { CartePage } from './../pages/carte/carte';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, NavController, MenuController, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { PdvService } from '../providers/pdv/pdv.service';
import { OrdersService } from '../providers/order/orders.service';
import { FamilyService } from '../providers/family/family.service';
import { WebSiteUsersService } from '../providers/webSiteUsers/webSiteUsers.service';
// import { Facebook } from '@ionic-native/facebook';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = 'HomePage';
  compositions: any[] = [];
  itemsCompositions: any[] = [];
  selectedCompForSearch: any[] = [];
  searchElement: String = "";
  selectedComp = [];
  log: boolean = false;
  date = new Date();
  alert = "";
  window:any;
  language = "fr";
  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private pdvService: PdvService,
    private ordersService: OrdersService,
    private familyService: FamilyService,
    private menuCtrl: MenuController,
    private webSiteUsersService: WebSiteUsersService,
    private alertCtrl: AlertController,
    // private googlePlus: GooglePlus,
    // private fb: Facebook
  ) {
    localStorage.setItem('language', this.language);
    this.initializeApp();
    if (localStorage.getItem('token')) {
      this.webSiteUsersService.listener.next(true);
    }
    this.pdvService.getModesByPdv().subscribe(
      (data: any[]) => {
        this.pdvService.orderTypes.next(data);
        if (data.length > 0) {
          this.ordersService.orderType.next(data[0].id);
        }
      }
    );
    const subs3 = this.pdvService.pdv.subscribe(
      (data) => {
        this.ordersService.discount = data.discount;
        this.ordersService.discountFrom = data.discountFrom;
      }
    )
    this.pdvService.getPdvInfo().subscribe(
      (data: any) => {
        this.pdvService.nbrOffersAuthorizedSite.next(data.nbrOffersAuthorizedSite);
        this.pdvService.pdv.next(data);
        this.ordersService.enablePayement.next(data.enablePayement);
        this.ordersService.amountMiniDelivery.next(data.amountMiniOrder);
        this.ordersService.enablePayement.next(data.enablePayement);
        if (data.alert) {
          this.alert = data.alert;
          const confirm = this.alertCtrl.create({
            message: data.alert,
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                }
              }
            ]
          });
          confirm.present();
        }
      }
    )
    this.familyService.getFamiliesOfCarte().subscribe(
      (families: any[]) => {
        let fa = families.map(f => { f.url = f.label.trim().replace(' ', '-'); f.label = f.label.trim(); return f });
        this.familyService.families.next(fa);
      })
    this.familyService.getMenuCategoriesOfCarte().subscribe(
      (menucategories: any[]) => {
        let categories = menucategories.map(f => { f.url = f.name.trim().replace(' ', '-'); f.name = f.name.trim(); return f });
        this.familyService.menucategories.next(categories);
      }
    )
    const subs1 = this.webSiteUsersService.listener.subscribe(
      log => {
        this.log = log
      }
    )
    this.getCompositionsOfCarte();
    // platform.ready().then(() => {
    //   statusBar.styleDefault();
    //   splashScreen.hide();

    //   if (platform.is('core') || platform.is('mobileweb')) {
    //     console.log("Platform is core or is mobile web");
    //   } else {
    //     var notificationOpenedCallback = ((jsonData) => {
    //       // this.ordersService.getOrderForProce(jsonData.notification.payload.additionalData.cmd).subscribe(
    //       //   (data: any) => {
    //       //     const modal = this.modalCtrl.create(OrderPage, { 'order': data });
    //       //     modal.present();
    //       //   }<
    //       // )
    //     });
    //     window["plugins"].OneSignal
    //       .startInit(this.pdvService.oneSignalAppId, this.pdvService.sender_id)
    //       .handleNotificationOpened(notificationOpenedCallback)
    //       .endInit();
    //     window["plugins"].OneSignal.addSubscriptionObserver((state) => {
    //       // if (!state.from.subscribed && state.to.subscribed) {
    //       // localStorage.setItem('deviceId', state.to.userId)
    //       // alert(state.to.userId);
    //       // this.webSiteUsersService.addDevice(state.to.userId).subscribe()
    //       // }
    //     });
    //     window["plugins"].OneSignal.getIds((ids: any) => {
    //      // alert(JSON.stringify(ids));
    //       localStorage.setItem('deviceId', ids.userId)
    //       this.webSiteUsersService.addDevice(localStorage.getItem('deviceId')).subscribe()
    //       // if (!!localStorage.getItem('token')) {
    //       //   this.webSiteUsersService.addDevice(ids.userId).subscribe()                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    //       // }
    //     })
    //   }
    // });
  }

  getCompositionsOfCarte() {
    this.pdvService.getCompositionsOfCarte().subscribe(
      (compositions: any[]) => {
        this.compositions = compositions;
        this.itemsCompositions = compositions;
      }
    )
  }
switchLanguage(){
  if(this.language === 'fr'){
    this.language = 'eng';
  }else{
    this.language = 'fr';
  }
  localStorage.setItem('language', this.language);
}
  search() {
    this.selectedComp = this.compositions.filter(opt => opt.checked).map(opt => opt.id.toString());
    if (this.selectedComp.length > 0) {
      this.ordersService.selectedComp.next(this.selectedComp);
      this.getCompositionsOfCarte();
      this.nav.setRoot(CartePage, { from: "filter" });
      this.menuCtrl.enable(false, 'menu2');
    }
  }
  filterComp(value) {
    if (!value) this.assignComp();
    this.compositions = Object.assign([], this.itemsCompositions).filter(
      c => c.text.toLowerCase().indexOf(value.toLowerCase()) > -1
    )
  }
  assignComp() {
    this.compositions = Object.assign([], this.itemsCompositions);
  }
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.askTrackingPermission();
      this.readTrackingPermission();
    });
  }
  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window['cordova']) {
        console.log('trying to request permission ');
        window['cordova'].exec(win, fail, 'idfa', "requestPermission", []);
      }
    }

    function win(res) {
      console.log('success ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

readTrackingPermission() {

    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window['cordova']) {
        window['cordova'].exec(win, fail, 'idfa', "getInfo", []);
      }
    }

    function win(res) {
      console.log('success  ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }
  openPage(page) {
    this.nav.setRoot(page);
  }

  logout() {
    const confirm = this.alertCtrl.create({
      message: 'Voulez-vous se déconnecter?',
      buttons: [
        {
          text: 'Non',
          handler: () => {
          }
        },
        {
          text: 'Oui',
          handler: () => {
            localStorage.clear();
            this.webSiteUsersService.listener.next(false);
            // this.googlePlus.disconnect()
            //   .then(res => console.log(res))
            //   .catch(err => console.error(err));
            // this.fb.logout()
            //   .then(res => console.log(res))
            //   .catch(e => console.log('Error logout from Facebook', e));
            this.nav.setRoot('HomePage');
          }
        }
      ]
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts